var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editing)?_c('QuillInputS',{attrs:{"name":"body","display-name":"","placeholder":"Body here","value":_vm.component.quill},on:{"quillChanged":_vm.quillChanged}}):_c('div',[_vm._v("\n        "+_vm._s(_vm.textOnly(_vm.component.html))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }